import GridItem from 'components/Grid/GridItem';
import classNames from 'classnames';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CustomAvatar from 'components/CustomAvatar/CustomAvatar';
import Business from '@material-ui/icons/BusinessOutlined';
import CanPerform from 'components/CanPerform/CanPerform';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';
import { BodyS, DisplayS } from 'components/Typography/Typography';
import DetailsRow from './DetailsRow';
import GridContainer from 'components/Grid/GridContainer';
import React, { ChangeEvent, createRef } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { documentTypeToString } from 'utils/documentTypeToString/documentTypeToString';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IOrganizationDetailsHeaderProps {
	account: types.organizations.IAccount;
	accountPhoto: string | undefined;
	handleImageChange: (e: ChangeEvent<HTMLInputElement>) => void;
	setPhoto: (base64photo: string) => void;
}

const OrganizationDetailsHeader = ({
	account,
	accountPhoto,
	handleImageChange,
	setPhoto,
}: IOrganizationDetailsHeaderProps) => {
	const classes = useStyles();
	let fileInput = createRef<HTMLInputElement>();

	const handleClick = () => fileInput?.current?.click();

	const handleRemove = () => {
		setPhoto('');
		fileInput!.current!.value = '';
	};

	return (
		<GridContainer>
			<GridItem
				className={classNames({
					[classes.avatarGridItem]: true,
					[classes.avatarSet]: accountPhoto,
				})}
			>
				<Card>
					<CardBody>
						<input type="file" onChange={handleImageChange} ref={fileInput} />
						<CustomAvatar
							placeholderIcon={<Business />}
							image={accountPhoto}
							alt="Organization card icon"
						/>
						<CanPerform
							action="organization:edit-photo"
							yes={
								<ConditionalRender
									show={!!accountPhoto}
									onTrue={() => (
										<>
											<Button
												color="tertiary-light"
												size="sm"
												className={classes.editButton}
												onClick={handleClick}
											>
												{translate('edit.image')}
											</Button>
											<Button
												color="tertiary-light"
												size="sm"
												className={classes.deleteButton}
												onClick={handleRemove}
											>
												{translate('delete.photo')}
											</Button>
										</>
									)}
									onFalse={() => (
										<>
											<Button color="tertiary-light" size="sm" onClick={handleClick}>
												{translate('add.image')}
											</Button>
										</>
									)}
								/>
							}
						/>
					</CardBody>
				</Card>
			</GridItem>
			<GridItem className={classes.accountInfoGridItem}>
				<Card>
					<CardBody>
						<div>
							<div className={classes.accountInfoCaption}>
								<BodyS color="secondary-light">{translate('organization.name')}</BodyS>
							</div>
							<DisplayS color="primary-light" disableMargin>
								{account.accountDetails.accountName}
							</DisplayS>
						</div>
						<div>
							<DetailsRow
								label={documentTypeToString(account.accountDetails.documentType)}
								value={account.accountDetails.documentId}
							/>
						</div>
					</CardBody>
				</Card>
			</GridItem>
		</GridContainer>
	);
};

export default OrganizationDetailsHeader;
